import { createFileRoute } from '@tanstack/react-router';

import { CompaniesPage } from '@/features/admin/components/companies-page';

export const Route = createFileRoute('/admin/companies')({
  component: CompaniesPage,
});
